import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useDropzone } from 'react-dropzone';
import { useToasts } from 'react-toast-notifications';
import { useAccount } from 'wagmi';
import { addLoader, fetchUpdateProfile, removeLoader } from '../../redux/slices/UserSlice';
import { IPFStoURL } from '../../helper/functions';
import { DEFAULT_IMAGES } from '../../helper/constant';

const ImageUploader = ({ type }) => {
    const profile = useSelector((state) => state.user.profile);
    const banner = useSelector((state) => state.user.banner);
    const [file, setFile] = useState(null);
    const { addToast } = useToasts();
    const { address } = useAccount();
    const dispatch = useDispatch();

    const onDrop = async (acceptedFiles) => {
        try {
            dispatch(addLoader())
            const uploadedFile = acceptedFiles[0];
            setFile(uploadedFile);

            const formData = new FormData();
            formData.append('file', uploadedFile);

            const metadata = JSON.stringify({
                name: uploadedFile.name,
            });
            formData.append("pinataMetadata", metadata);

            const options = JSON.stringify({
                cidVersion: 0,
            });
            formData.append("pinataOptions", options);

            const res = await fetch(
                "https://api.pinata.cloud/pinning/pinFileToIPFS",
                {
                    method: "POST",
                    headers: {
                        Authorization: `Bearer ${process.env.REACT_APP_PINATA_JWT}`,
                    },
                    body: formData,
                }
            );
            if (!res.ok) {
                dispatch(removeLoader())
                addToast('Failed to upload file.Please try again.', { appearance: 'error', });
            }
            const resData = await res.json();
            if (resData && resData.IpfsHash) {
                type === 'banner' ?
                    dispatch(fetchUpdateProfile({
                        address,
                        update : {banner: resData.IpfsHash}
                    })) :
                    dispatch(fetchUpdateProfile({
                        address,
                        update: {profile : resData.IpfsHash}
                    }))

            }
        } catch (error) {
            dispatch(removeLoader())
            addToast(error.message, { appearance: 'error', });
            console.error('Error uploading file to IPFS:', error);
        }
    };

    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        multiple: false,
    });
    return (
        <div {...getRootProps()} className={`image-uploader ${type}-uploader`}>
            <input {...getInputProps()} />
            {file ? (
                <img src={URL.createObjectURL(file)} alt="Uploaded" className="uploaded-image img-fluid" />
            ) : (
                type === 'banner' ? (
                    <img
                        src={banner ? IPFStoURL(banner) : IPFStoURL(DEFAULT_IMAGES.profile.banner)}
                        alt="banner"
                        className="default-image img-fluid"
                        height="200px"
                    />
                ) : (
                    <img
                        src={profile ? IPFStoURL(profile) : IPFStoURL(DEFAULT_IMAGES.profile.profile)}
                        alt="banner"
                        className="default-image img-fluid"
                        height="200px"
                    />
                )
            )}
        </div >
    );
};

export default ImageUploader;
